import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { Add, FilterAlt } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import Table from "../../../components/Table"
import { useEffect, useState } from "react"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index.js";
import WorkflowStepFilterDialog from './components/WorkflowStepFilterDialog.js';

const WorkflowStepList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.operationWorkflowStepStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.operationWorkflowStepStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.operationWorkflowStepStore?.totalPages);

    const [workflowStepData, setWorkflowStepData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        workflowDictionaryId: "",
        stepTypeId: "",
        schemaId: ""
    });

    useEffect(() => {
        fetchWorkflowStepList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchWorkflowStepList = async () => {
        setCircleLoading(true);
        try {      
        let url = `/reference/orchestration/work-flow-steps?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`
        if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.workflowDictionaryId !== "" && filterData.workflowDictionaryId !== null && filterData.workflowDictionaryId !== undefined) {
            url += `&workflowDictionaryId=${filterData.workflowDictionaryId}`;
        }
        if(filterData.stepTypeId !== "" && filterData.stepTypeId !== null && filterData.stepTypeId !== undefined) {
            url += `&stepTypeId=${filterData.stepTypeId}`;
        }
        if(filterData.schemaId !== "" && filterData.schemaId !== null && filterData.schemaId !== undefined) {
            url += `&schemaId=${filterData.schemaId}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setWorkflowStepData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Workflow List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Api List:', error);
            showSnackbar(error?.message, "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/orchestration/workflow-steps-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Error deleting Insurer Registry data", "error");
        }
    };
    //table mapping
    const workflowBindingTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },            
            { key: "stepName", label: "Step Name", renderCell: (row) => row.stepName },
            { key: "StepType", label: "Step Type", renderCell: (row) => row.stepType },
            { key: "workflowDefinition", label: "Workflow Definition", renderCell: (row) => row.workflowDefinition },
            {
            key: "isActive",
            label: "Status",
            renderCell: (row) => (
                <span>
                {row.isActive ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                )}
                </span>
            )
            },
        ],
        rows: workflowStepData?.map((item, index) => ({
            id: item?.id,
            sno: index + 1,
            stepName: item?.stepName || "",
            stepType: item?.stepType?.keyName || "",
            workflowDefinition: item?.workflowDefinition?.name || "",
            isActive: item?.isActive
        })),
    };
    
    const actions = {
        edit: true,
        view: true,
        delete: true,
    
        onEdit: (row) => {
            navigate(`/operation/workflow-step/workflow-step-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/operation/workflow-step/workflow-step-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader title={(
            <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Workflow Step List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of Workflow Steps.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt />}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                        variant="gradient"
                        color="dark"
                        size="small"
                        startIcon={<Add />}
                        onClick={() => navigate('/operation/workflow-step/workflow-step-details')}
                    >
                        Workflow Step
                    </MaterialButton>
                </Stack>
            </Stack>
            )} 
        />
        <CardContent>
          <Table
          columns={workflowBindingTable?.columns}
          data={workflowBindingTable?.rows}
          actions={actions}
          pagination={{
              totalPages,
              currentPage,
              onPageChange: (page) => handlePaginationChange(page),
              rowsPerPage,
              onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
              rowsPerPageOptions: [5, 10, 15, 20],
          }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel="No Workflow Step Data found"
          handleSearch={handleSearch}
          />
        </CardContent>
        <WorkflowStepFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);
            fetchWorkflowStepList();
        }}
        />
    </DashboardLayout>
  )
}

export default WorkflowStepList